module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic01.a94bd2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic01.png
// module id = 519
// module chunks = 1